/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetEventSignup,
  FleetEventSignupAssignInput,
  FleetEventSignupCreateInput,
  FleetEventSignupUpdateInput,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Withdraw a member's signup (admin)
 */
export const destroyFleetEventSignup = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/fleet-event-signups/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetEventSignupMutationKey = () => ['destroyFleetEventSignup'] as const;

export const getDestroyFleetEventSignupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventSignup>>, TError,DestroyFleetEventSignupMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventSignup>>, TError,DestroyFleetEventSignupMutationVariables, TContext> => {

const mutationKey = getDestroyFleetEventSignupMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetEventSignup>>, DestroyFleetEventSignupMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyFleetEventSignup(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetEventSignupMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetEventSignup>>>

    export type DestroyFleetEventSignupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyFleetEventSignupMutationVariables = {id: string}

    /**
 * @summary Withdraw a member's signup (admin)
 */
export const useDestroyFleetEventSignup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventSignup>>, TError,DestroyFleetEventSignupMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetEventSignup>>,
        TError,
        DestroyFleetEventSignupMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetEventSignupMutationOptions(options), queryClient);
    }
    /**
 * @summary Admin: assign or update a signup
 */
export const assignFleetEventSignup = (
    id: MaybeRefOrGetter<string>,
    fleetEventSignupAssignInput: MaybeRefOrGetter<FleetEventSignupAssignInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
fleetEventSignupAssignInput = toValue(fleetEventSignupAssignInput);

      return axiosClient<FleetEventSignup>(
      {url: `/fleet-event-signups/${id}/assign`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventSignupAssignInput, signal
    },
      );
    }




export const getAssignFleetEventSignupMutationKey = () => ['assignFleetEventSignup'] as const;

export const getAssignFleetEventSignupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignFleetEventSignup>>, TError,AssignFleetEventSignupMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof assignFleetEventSignup>>, TError,AssignFleetEventSignupMutationVariables, TContext> => {

const mutationKey = getAssignFleetEventSignupMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignFleetEventSignup>>, AssignFleetEventSignupMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  assignFleetEventSignup(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignFleetEventSignupMutationResult = NonNullable<Awaited<ReturnType<typeof assignFleetEventSignup>>>
    export type AssignFleetEventSignupMutationBody = FleetEventSignupAssignInput
    export type AssignFleetEventSignupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type AssignFleetEventSignupMutationVariables = {id: string;data: FleetEventSignupAssignInput}

    /**
 * @summary Admin: assign or update a signup
 */
export const useAssignFleetEventSignup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignFleetEventSignup>>, TError,AssignFleetEventSignupMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof assignFleetEventSignup>>,
        TError,
        AssignFleetEventSignupMutationVariables,
        TContext
      > => {
      return useMutation(getAssignFleetEventSignupMutationOptions(options), queryClient);
    }
    /**
 * @summary Sign up for slot
 */
export const signupFleetEventSlot = (
    id: MaybeRefOrGetter<string>,
    fleetEventSignupCreateInput: MaybeRefOrGetter<FleetEventSignupCreateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
fleetEventSignupCreateInput = toValue(fleetEventSignupCreateInput);

      return axiosClient<FleetEventSignup>(
      {url: `/fleet-event-slots/${id}/signup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventSignupCreateInput, signal
    },
      );
    }




export const getSignupFleetEventSlotMutationKey = () => ['signupFleetEventSlot'] as const;

export const getSignupFleetEventSlotMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signupFleetEventSlot>>, TError,SignupFleetEventSlotMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof signupFleetEventSlot>>, TError,SignupFleetEventSlotMutationVariables, TContext> => {

const mutationKey = getSignupFleetEventSlotMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signupFleetEventSlot>>, SignupFleetEventSlotMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  signupFleetEventSlot(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SignupFleetEventSlotMutationResult = NonNullable<Awaited<ReturnType<typeof signupFleetEventSlot>>>
    export type SignupFleetEventSlotMutationBody = FleetEventSignupCreateInput
    export type SignupFleetEventSlotMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type SignupFleetEventSlotMutationVariables = {id: string;data: FleetEventSignupCreateInput}

    /**
 * @summary Sign up for slot
 */
export const useSignupFleetEventSlot = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signupFleetEventSlot>>, TError,SignupFleetEventSlotMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof signupFleetEventSlot>>,
        TError,
        SignupFleetEventSlotMutationVariables,
        TContext
      > => {
      return useMutation(getSignupFleetEventSlotMutationOptions(options), queryClient);
    }
    /**
 * @summary Update own signup
 */
export const updateFleetEventSignup = (
    id: MaybeRefOrGetter<string>,
    fleetEventSignupUpdateInput: MaybeRefOrGetter<FleetEventSignupUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
fleetEventSignupUpdateInput = toValue(fleetEventSignupUpdateInput);

      return axiosClient<FleetEventSignup>(
      {url: `/fleet-event-slots/${id}/signup`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventSignupUpdateInput, signal
    },
      );
    }




export const getUpdateFleetEventSignupMutationKey = () => ['updateFleetEventSignup'] as const;

export const getUpdateFleetEventSignupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventSignup>>, TError,UpdateFleetEventSignupMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventSignup>>, TError,UpdateFleetEventSignupMutationVariables, TContext> => {

const mutationKey = getUpdateFleetEventSignupMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetEventSignup>>, UpdateFleetEventSignupMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateFleetEventSignup(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetEventSignupMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetEventSignup>>>
    export type UpdateFleetEventSignupMutationBody = FleetEventSignupUpdateInput
    export type UpdateFleetEventSignupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateFleetEventSignupMutationVariables = {id: string;data: FleetEventSignupUpdateInput}

    /**
 * @summary Update own signup
 */
export const useUpdateFleetEventSignup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventSignup>>, TError,UpdateFleetEventSignupMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetEventSignup>>,
        TError,
        UpdateFleetEventSignupMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetEventSignupMutationOptions(options), queryClient);
    }
    /**
 * @summary Withdraw own signup
 */
export const withdrawFleetEventSignup = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/fleet-event-slots/${id}/signup`, method: 'DELETE', signal
    },
      );
    }




export const getWithdrawFleetEventSignupMutationKey = () => ['withdrawFleetEventSignup'] as const;

export const getWithdrawFleetEventSignupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdrawFleetEventSignup>>, TError,WithdrawFleetEventSignupMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof withdrawFleetEventSignup>>, TError,WithdrawFleetEventSignupMutationVariables, TContext> => {

const mutationKey = getWithdrawFleetEventSignupMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof withdrawFleetEventSignup>>, WithdrawFleetEventSignupMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  withdrawFleetEventSignup(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WithdrawFleetEventSignupMutationResult = NonNullable<Awaited<ReturnType<typeof withdrawFleetEventSignup>>>

    export type WithdrawFleetEventSignupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type WithdrawFleetEventSignupMutationVariables = {id: string}

    /**
 * @summary Withdraw own signup
 */
export const useWithdrawFleetEventSignup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdrawFleetEventSignup>>, TError,WithdrawFleetEventSignupMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof withdrawFleetEventSignup>>,
        TError,
        WithdrawFleetEventSignupMutationVariables,
        TContext
      > => {
      return useMutation(getWithdrawFleetEventSignupMutationOptions(options), queryClient);
    }
    /**
 * @summary Sign up to event without picking a slot
 */
export const signupFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    fleetEventSignupCreateInput: MaybeRefOrGetter<FleetEventSignupCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
fleetEventSignupCreateInput = toValue(fleetEventSignupCreateInput);

      return axiosClient<FleetEventSignup>(
      {url: `/fleets/${fleetSlug}/events/${slug}/signup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventSignupCreateInput, signal
    },
      );
    }




export const getSignupFleetEventMutationKey = () => ['signupFleetEvent'] as const;

export const getSignupFleetEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signupFleetEvent>>, TError,SignupFleetEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof signupFleetEvent>>, TError,SignupFleetEventMutationVariables, TContext> => {

const mutationKey = getSignupFleetEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signupFleetEvent>>, SignupFleetEventMutationVariables> = (props) => {
          const {fleetSlug,slug,data} = props ?? {};

          return  signupFleetEvent(fleetSlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SignupFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof signupFleetEvent>>>
    export type SignupFleetEventMutationBody = FleetEventSignupCreateInput
    export type SignupFleetEventMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type SignupFleetEventMutationVariables = {fleetSlug: string;slug: string;data: FleetEventSignupCreateInput}

    /**
 * @summary Sign up to event without picking a slot
 */
export const useSignupFleetEvent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signupFleetEvent>>, TError,SignupFleetEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof signupFleetEvent>>,
        TError,
        SignupFleetEventMutationVariables,
        TContext
      > => {
      return useMutation(getSignupFleetEventMutationOptions(options), queryClient);
    }
